import { defineNuxtPlugin, useCookie, useRouter, useRuntimeConfig, useState } from "#app";
import { posthog } from "posthog-js";
import { defu } from "defu";
export default defineNuxtPlugin({
  name: "posthog",
  enforce: "pre",
  setup: async () => {
    const config = useRuntimeConfig().public.posthog;
    if (config.disabled)
      return {
        provide: {
          posthog: "Deprecated: use $clientPosthog instead.",
          clientPosthog: null
        }
      };
    const posthogFeatureFlags = useState("ph-feature-flags");
    const posthogFeatureFlagPayloads = useState("ph-feature-flag-payloads");
    const clientOptions = defu(config.clientOptions ?? {}, {
      api_host: config.host,
      capture_pageview: false,
      bootstrap: {
        featureFlags: posthogFeatureFlags.value,
        featureFlagPayloads: posthogFeatureFlagPayloads.value
      },
      loaded: (posthog2) => {
        if (import.meta.env.MODE === "development")
          posthog2.debug();
      }
    });
    const posthogClient = posthog.init(config.publicKey, clientOptions);
    const identity = useCookie("ph-identify");
    identity.value = posthog.get_distinct_id();
    if (config.capturePageViews) {
      const router = useRouter();
      router.afterEach((to) => {
        posthog.capture("$pageview", {
          current_url: to.fullPath
        });
      });
    }
    posthog.onFeatureFlags((flags, featureFlags) => {
      posthogFeatureFlags.value = featureFlags;
      posthogFeatureFlagPayloads.value = flags.reduce((acc, flag) => {
        acc[flag] = posthog.getFeatureFlagPayload(flag);
        return acc;
      }, {});
    });
    return {
      provide: {
        clientPosthog: posthogClient ? posthogClient : null,
        posthog: "Deprecated: use $clientPosthog instead."
      }
    };
  }
});
